import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";
import Highlight from "@/components/base/Highlight";

interface MovieCardProps {
  movie: Movie;
  query?: string;
}

export default function MovieCard({ movie, query }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition duration-300 hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 电影海报`}
          title={`${movie.title} 小黄人电影 海报`}
          className="h-full w-full object-top transition duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-2.5 py-1 text-[11px] font-semibold text-foreground-950">
          {movie.type}
        </span>
        <span className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-foreground-950/70 px-2.5 py-1 text-[11px] font-semibold text-background-50">
          <i className="ri-star-fill text-primary-400"></i>
          {movie.rating}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <div className="flex items-center gap-2 text-xs text-foreground-500">
          <span className="font-medium text-secondary-700">{movie.year}</span>
          <span className="h-1 w-1 rounded-full bg-foreground-300"></span>
          <span>{movie.duration}</span>
        </div>
        <h3 className="mt-1.5 text-base font-bold text-foreground-950 transition group-hover:text-primary-700">
          <Highlight text={movie.title} query={query} />
        </h3>
        <p className="mt-0.5 text-xs text-foreground-500">{movie.originalTitle}</p>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          <Highlight text={movie.synopsis} query={query} />
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {movie.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-background-100 px-2 py-0.5 text-[11px] text-foreground-600"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}